import type { Operator } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

const fetchApi = async (
  args: FetchApiArgs<{ operatorId: number }, string, string>
): Promise<FetchApiResponse<Operator>> => {
  const {
    signal,
    additionalParams: { operatorId }
  } = args

  const { data } = await streamingRestApi.endpoints.operators.get(operatorId, signal)

  return {
    content: [data],
    totalElements: [data].length
  }
}

export const useOperatorStoreDGE = createBaseTableStore({
  storeName: 'DGE Operator',
  fetchApi
})
